import { Component, Inject, Input } from '@angular/core';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';

@Component({
  selector: 'app-info-card',
  templateUrl: './info-card.component.html',
  styleUrl: './info-card.component.scss',
  standalone: false
})
export class InfoCardComponent {
  @Input() level: 'info' | 'warning' | 'error' = 'info';
  @Input() title: string = undefined;
  @Input() message: string = undefined;
  @Input() maxWidth: string = 'unset';
  @Input() hideTitle = false;
  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {}
}
